var _defs, _circle, _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".neutral-1{fill:#f2af0c;}.neutral-2{stroke:#000;}.neutral-2,.neutral-3{stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.neutral-3{fill:none;stroke:#1d1d1b;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "icon_rating_bg",
    className: "neutral-1",
    cx: 50,
    cy: 50,
    r: 48.83
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "neutral-2",
    x1: 28.48,
    y1: 59.75,
    x2: 56.39,
    y2: 58.61
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "neutral-3",
    d: "M38.53,32S36,46.66,27.72,46.58s-9.23-11.31-9.06-16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "neutral-3",
    d: "M72.91,35.45S70.33,50.08,62.1,50,52.87,38.69,53,34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.a409d32e94c5882579f4a52a7b82cc1b.svg";
export { ForwardRef as ReactComponent };